import { render, staticRenderFns } from "./VsSelect.vue?vue&type=template&id=31218cf2&scoped=true&"
import script from "./VsSelect.vue?vue&type=script&lang=js&"
export * from "./VsSelect.vue?vue&type=script&lang=js&"
import style0 from "./VsSelect.vue?vue&type=style&index=0&id=31218cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31218cf2",
  null
  
)

export default component.exports